import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/";

class AlertService {
  getPublicContent(q) {
    return axios
      .post(
        API_URL + "alerts",
        {
          q,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error(err.response.data);
      });
  }

  getUserBoard() {
    return axios.get(API_URL + "user", { headers: authHeader() });
  }

  async getAlerts(data) {
    console.log(data);
    try {
      const response = await axios.post(
        API_URL + "alerts",
        {
          data,
        },
        { headers: authHeader() }
      );
      return response.data;
    } catch (err) {
      console.log(err);
      throw new Error(err.response.data);
    }
  }

  postQueryAlerts(q) {
    return axios
      .post(
        API_URL + "queryAlerts",
        {
          q,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  postNotes(id, notes, i) {
    return axios
      .post(
        API_URL + "postNotes",
        {
          id,
          notes,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        if (response.data.accessToken) {
          console.log("access token created " + response.data.accessToken);
        }
        return response.data;
      });
  }

  postStarBookmark(id) {
    return axios
      .post(
        API_URL + "postBookmark",
        {
          id,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error(err.response.data);
      });
  }

  getShortList() {
    return axios
      .get(API_URL + "shortList", { headers: authHeader() })
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error(err.response.data);
      });
  }

  getTickerInfo(tickerName, days) {
    return axios
      .post(
        API_URL + "tickerInfo",
        {
          tickerName,
          days,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error(err.response.data);
      });
  }

  getTickersByDate(days) {
    return axios
      .post(
        API_URL + "tickersByDate",
        {
          days,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error(err.response.data);
      });
  }
  getTickersByRange(from, to) {
    return axios
      .post(
        API_URL + "tickersByDate",
        {
          from,
          to,
        },
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        throw new Error(err.response.data);
      });
  }
}

export default new AlertService();
